<template>
    <div id="loan-detail">
        <!--=====================================-->
        <!--=        Service Area Start         =-->
        <!--=====================================-->
        <section class="section bg-color-dark">
            <div class="container">
                <div class="section-heading heading-light-left">
                    <span class="subtitle primary">Condiciones.</span>
                    <h2 class="white font-weight-100">¿Qué <span class="bold">características</span> tiene el crédito?
                    </h2>
                </div>
                <div class="row">

                    <!-- MONTO TITTLE -->
                    <div class="row mb--30" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                        <div class="col-12 display-flex">
                            <h6 class="primary bold">
                                Monto
                            </h6>
                            <div class="vs-divider">
                            </div>
                        </div>

                        <div v-if="isPersonal" class="row">
                            <div class="col-sm-6 col-md-4 white font-weight-100">
                                <p class="mb--10"><span class="bold">$10,000</span> a <span class="bold">$350,000MXN</span></p>
                                <p class="font-weight-100 mb--10">Crédito personal para personas físicas.</p>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div v-if="!isBusiness" class="col-sm-6 col-md-4 white font-weight-100">
                                <p class="mb--10"><span class="bold">$50,000</span> a <span class="bold">$350,000MXN</span></p>
                                <p class="font-weight-100 mb--10">Crédito personal para personas físicas.</p>
                            </div>
    
                            <div class="col-sm-6 col-md-8 white font-weight-100">
                                <p class="mb--10"><span class="bold">$50,000</span> a <span class="bold">$10,000,000MXN</span>
                                </p>
                                <p class="font-weight-100 mb--10">Crédito empresarial para personas físicas con actividad
                                    empresarial y personas morales.</p>
                            </div>
                        </div>
                    </div>

                    <!-- OPTIONS -->
                    <div class="row white" data-sal="slide-up" data-sal-duration="800" data-sal-delay="150">
                        <!-- PLAZO -->
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <h6 class="primary bold mb--10">
                                Plazo
                            </h6>
                            <p>
                                6 a 60 meses
                            </p>
                        </div>
                        
                        <!-- PLAZO -->
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <h6 class="primary bold mb--10">
                                Garantía de crédito
                            </h6>
                            <p>{{ getGuarantees }}</p>
                        </div>
                        <!-- PLAZO -->
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <h6 class="primary bold mb--10">
                                Frecuencia de pagos
                            </h6>
                            <p>Mensual</p>
                        </div>
                        <!-- PLAZO -->
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <h6 class="primary bold w-75 mb--10">
                                Esquema de Pagos
                            </h6>
                            <p>Pagos fijos o variables</p>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <div class="display-flex">
                                <h6 class="primary bold mb--10">
                                    Tasa anual
                                </h6>
                            </div>
                            <p> Desde {{ getRangeLow }} </p>
                        </div>
                    </div>

                    <!-- COMISIONES -->
                    <div class="row mb--30 white" data-sal="slide-up" data-sal-duration="800" data-sal-delay="00">
                        <div class="col-12 display-flex">
                            <h6 class="primary bold">
                                Comisiones
                            </h6>
                            <div class="vs-divider">
                            </div>
                        </div>

                        <div class="col-sm-6 col-md-3 white font-weight-100">
                            <p class="mb--10 bold">Pre-originación</p>
                            <p class="font-weight-100 mb--10">2% del monto solicitado (más IVA). Incluido en el monto financiado.</p>
                        </div>

                        <div class="col-sm-6 col-md-4 white font-weight-100">
                            <p class="mb--10 bold">Administración</p>
                            <p class="font-weight-100 mb--10">1% mensual sobre el saldo insoluto (más IVA). Pagado dentro de
                                las mensualidades.</p>
                        </div>

                        <div class="col-sm-6 col-md-2 white font-weight-100">
                            <p class="mb--10 bold"> Pago tardío</p>
                            <p class="font-weight-100 mb--10">$150 mxn por evento (más IVA).</p>
                        </div>
                    </div>

                    <div class="row white" data-sal="slide-up" data-sal-duration="800" data-sal-delay="150">
                        <div class="col-sm-12 col-md-12 col-lg-12 ">                            
                            <span v-html='cat'></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "LoanDetail",
    props: ["isBusiness", "isPersonal"],
    components: {
    },
    data() {
        return {
            qualification: [],
            isMounted: false,
            cat: "",
        }
    },
    computed: {
        getRangeLow() {
            if(this.isMounted) {
                return (this.qualification[1].rangeLow * 100).toFixed(2) + "%";
            } else {
                "--%"
            }
        }, 
        getGuarantees() {
            if(this.isBusiness) {
                return "Cuentas por cobrar";
            }

            if(this.isPersonal) {
                return "Obligado solidario";
            } 

            if(this.isBusiness == false && this.isPersonal == undefined) {
                return "Bien mueble";
            }
        },
        currentStep() {
            return this.$route.name;
        },
        currentProduct() {
            let product = 1;
            if (this.currentStep == "forProductsPage") {
                product = 1;
            } else if (this.currentStep == "forBusinessPage") {
                product = 4;
            } else if (this.currentStep == "forPersonalPage") {
                product = 5;
            }

            return product;
        },
    },
    async mounted() {
        this.imgSrc = require('@assets/images/Score/CALIFICACION.jpg');
        this.isMounted = false;
        this.qualification = await this.getQualification();
        this.cat = await this.getCATText(this.currentProduct);
        this.isMounted = true;
    },
}

</script>

<style scoped>
.container {
    padding: 3rem;

}
</style>